import cn from 'clsx'
import { Button, IconPlusAdd } from '@tracklib/kit'
import styles from './createbox.css'

type CreateBoxProps = {
  text?: string
  to?: string
  query?: Record<string, unknown>
  modal?: boolean
  onClick?: (arg: unknown) => unknown
  className?: string
  datatesting?: string
}

const CreateBox = ({ text = 'Create new', to, query, modal, onClick, className, datatesting }: CreateBoxProps): JSX.Element => (
  <li className={cn(styles.wrapper, className)}>
    <Button to={to} query={query} modal={modal} onClick={onClick} datatesting={datatesting}>
      <div className={styles.create}>
        <div className={styles.iconWrapper}>
          <IconPlusAdd />
        </div>
        <p className={styles.title}>{text}</p>
      </div>
    </Button>
  </li>
)

export default CreateBox
